/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class LockConfigScopeDetailsForAzureServiceAccount extends models.LockConfigScopeDetailsBaseForServiceAccount {
    constructor() {
        super();
        this.setDiscriminator("LockConfigScopeDetailsForAzureServiceAccount");
    }

    getFixupPrototypeFunction() { return LockConfigScopeDetailsForAzureServiceAccount.fixupPrototype; }

    static newInstance(model: Partial<LockConfigScopeDetailsForAzureServiceAccount>): LockConfigScopeDetailsForAzureServiceAccount {
        let obj = Object.assign(new LockConfigScopeDetailsForAzureServiceAccount(), model);
        LockConfigScopeDetailsForAzureServiceAccount.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<LockConfigScopeDetailsForAzureServiceAccount>): LockConfigScopeDetailsForAzureServiceAccount {
        if (!model) return null;
        return LockConfigScopeDetailsForAzureServiceAccount.newInstance(<LockConfigScopeDetailsForAzureServiceAccount> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: LockConfigScopeDetailsForAzureServiceAccount) {
        if (!obj) return;

        models.LockConfigScopeDetailsForAzureServiceAccount.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: LockConfigScopeDetailsForAzureServiceAccount): boolean {
        if (models.LockConfigScopeDetailsBaseForServiceAccount.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, LockConfigScopeDetailsForAzureServiceAccount.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.resource_groups) {
            for (let val of this.resource_groups) {
                models.ScopeResourceGroup.fixupPrototype(val);
            }
        }
    }

    /**
     * List of Azure Resource Groups
     */
    resource_groups: Array<models.ScopeResourceGroup>;

}
